import {
  IFileVariantResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IFileVariantResponseInstance'
import {FileVariantType} from '@toolify/server/src/models/mongoose/FileVariantModel/enum/FileVariantType'
import {
  IImageToImageFileConversionTypeStrategyInterfaces,
} from '@toolify/server/src/services/FileVariantService/strategies/FileConversionTypeStrategies/ImageToImageFileConversionTypeStrategy/types/IImageToImageFileConversionTypeStrategyInterfaces'

type ImageMeta = IImageToImageFileConversionTypeStrategyInterfaces['meta']
type ImagePayload = IImageToImageFileConversionTypeStrategyInterfaces['payload']

/** Still = missing/false `meta.isAnimated` (legacy-safe). Animated = explicit true. Prefers WebP via payload.format. */
export function filterImageFileVariants(
  fileVariants: IFileVariantResponseInstance[] | null | undefined,
  animated = false,
): IFileVariantResponseInstance[] {
  const matched = (fileVariants || []).filter(fileVariant => {
    if(fileVariant?.type !== FileVariantType.Image) {
      return false
    }
    return !!(fileVariant.meta as ImageMeta | null | undefined)?.isAnimated === animated
  })
  const webp = matched.filter(fileVariant => (
    (fileVariant.payload as ImagePayload | null | undefined)?.format === 'webp'
  ))
  return webp.length ? webp : matched
}
